import {
  SAVE_USER_ACCOUNTS,
  APPEND_USER_ACCOUNTS,
  SAVE_ACCOUNTS_TOTAL,
  SAVE_ACCOUNTS_META,
  SAVE_SELECTED_ACCOUNTS,
  ACCOUNTS_SET_IS_LOADING,
} from "../actions/action-types";

const INITIAL_STATE = {
  accounts: [],
  selectedAccounts: [],
  isLoading: false,
  accountsTotal: 0,
  meta: null,
};

export default function _accountsReducer(state = [], action) {
  if (state.length === 0) {
    return INITIAL_STATE;
  }

  switch (action.type) {
    case SAVE_USER_ACCOUNTS:
      const { payload } = action;
      let accounts = {};
      for (const account in payload) {
        accounts[payload[account].id] = payload[account];
      }
      return {
        ...state,
        accounts,
      };
    case APPEND_USER_ACCOUNTS:
      let merged = { ...state.accounts };
      for (const account of action.payload) {
        merged[account.id] = account;
      }
      return {
        ...state,
        accounts: merged,
      };
    case SAVE_ACCOUNTS_TOTAL:
      return { ...state, accountsTotal: action.payload };
    case SAVE_SELECTED_ACCOUNTS:
      return {
        ...state,
        selectedAccounts: action.payload,
      };

    case ACCOUNTS_SET_IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    case SAVE_ACCOUNTS_META:
      return { ...state, meta: action.payload };

    default:
      return state;
  }
}
